import React, { useState } from "react";
import { UploadCloud } from "lucide-react";

const CreateFolderProject = () => {
  const [projectName, setProjectName] = useState("");
  const [clientName, setClientName] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFolderUpload = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleSubmit = async () => {
    if (!projectName || !clientName || files.length === 0) {
      alert("Please fill all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("project_name", projectName);
    formData.append("client_name", clientName);
    files.forEach((file) => formData.append("files", file));

    try {
      setLoading(true);
      await fetch(`${process.env.REACT_APP_API_URL}/projects/upload-folder`, {
        method: "POST",
        body: formData,
      });
      alert("Project Uploaded 🚀");
    } catch (err) {
      console.error(err);
      alert("Upload Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 text-white">
      <div className="bg-gradient-to-br from-[#1a1f3c] to-[#11152b] rounded-2xl p-8 shadow-xl flex gap-10">

        {/* LEFT SIDE FORM */}
        <div className="w-1/2">
          <h2 className="text-3xl font-semibold mb-2">Create Folder Project</h2>
          <p className="text-gray-400 mb-8">
            Upload complete drawing folder and auto-map relationships
          </p>

          <div className="mb-6">
            <label className="block mb-2 text-sm text-gray-300">
              Project Name
            </label>
            <input
              type="text"
              placeholder="Enter project name..."
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              className="w-full bg-[#0f1327] border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>

          <div className="mb-8">
            <label className="block mb-2 text-sm text-gray-300">
              Client Name
            </label>
            <input
              type="text"
              placeholder="Enter client name..."
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              className="w-full bg-[#0f1327] border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 py-3 rounded-lg font-medium transition"
          >
            {loading ? "Uploading..." : "Create Project"}
          </button>
        </div>

        {/* RIGHT SIDE UPLOAD CARD */}
        <div className="w-1/2 border border-purple-600/40 rounded-2xl p-8 bg-[#151936] flex flex-col items-center justify-center text-center">

          <div className="bg-purple-700/20 p-5 rounded-xl mb-6">
            <UploadCloud size={40} className="text-purple-400" />
          </div>

          <h3 className="text-xl font-semibold mb-2">
            Upload Drawing Folder
          </h3>

          <p className="text-gray-400 mb-6">
            Drag & drop your PDF folder here or browse
          </p>

          <input
            type="file"
            webkitdirectory="true"
            directory=""
            multiple
            accept=".pdf"
            onChange={handleFolderUpload}
            className="hidden"
            id="folderUpload"
          />

          <label
            htmlFor="folderUpload"
            className="cursor-pointer bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-3 rounded-lg font-medium hover:opacity-90 transition"
          >
            Browse Folder
          </label>

          {files.length > 0 && (
            <p className="text-sm text-gray-400 mt-6">
              {files.length} PDF files selected
            </p>
          )}

          <div className="mt-6 text-xs text-gray-500">
            Supported format: PDF only
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFolderProject;